import content from "@/pages/template-game-page/content";

const template = () =>
	import(
		/* webpackChunkName: "template-game-page" */ "@/pages/template-game-page"
	);

const generateGamePagesConfig = () => {
	const o = [];
	for (let pageName in content) {
		let data = content[pageName];

		o.push({
			path: data.path,
			name: pageName,
			component: template,
		});
	}

	return o;
};

const config = generateGamePagesConfig();
export default config;
